import { z } from "zod";

const NAME_PATTERN = /^[A-Za-z ]+$/;

export function createPersonNameSchema(label: string) {
  return z.preprocess(
    (value) => (typeof value === "string" ? value.trim() : value),
    z
      .string()
      .min(2, `${label} must be at least 2 characters`)
      .max(50, `${label} cannot exceed 50 characters`)
      .regex(NAME_PATTERN, `${label} must contain only letters`)
      .refine((value) => !/\s{2,}/.test(value), {
        message: `${label} cannot contain consecutive spaces`,
      })
      .refine((value) => !/(.)\1{4,}/i.test(value.replace(/\s/g, "")), {
        message: `${label} contains too many repeated characters`,
      })
  );
}

export function createOptionalPersonNameSchema(label: string) {
  return z.preprocess(
    (value) => (typeof value === "string" ? value.trim() : value),
    z
      .string()
      .optional()
      .refine((value) => !value || value.length >= 2, {
        message: `${label} must be at least 2 characters`,
      })
      .refine((value) => !value || value.length <= 50, {
        message: `${label} cannot exceed 50 characters`,
      })
      .refine((value) => !value || NAME_PATTERN.test(value), {
        message: `${label} must contain only letters`,
      })
      .refine((value) => !value || !/\s{2,}/.test(value), {
        message: `${label} cannot contain consecutive spaces`,
      })
      .refine((value) => !value || !/(.)\1{4,}/i.test(value.replace(/\s/g, "")), {
        message: `${label} contains too many repeated characters`,
      })
  );
}
